// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1DGWg","label":"Section_label__OUQsJ","contentWrap":"Section_contentWrap__2RU1Z","footer":"Section_footer__10B2m","footerInner":"Section_footerInner__8uZHw"};